const init_setting = {
  fontFamily: 'source-han-serif-japanese',
  fontSize: 18,
  lineHeight: 1.4,
  marginHorizontal: 0,
  marginVertical: 0
}

export default init_setting
